'use strict';

var _ = require('lodash');
var DemandTransparencyUntruncatedMdDtdGridTransformerFactory = function DemandTransparencyUntruncatedMdDtdGridTransformerFactory(DataTransformer, momentService) {
  function DemandTransparencyUntruncatedMdDtdGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'demand-transparency-untruncated-md-mode';
    this.targetType = 'demand-transparency-dtd-matrix';
    this.priority = 1;
  }
  DemandTransparencyUntruncatedMdDtdGridTransformer.prototype = Object.create(DataTransformer.prototype);
  DemandTransparencyUntruncatedMdDtdGridTransformer.constructor = DemandTransparencyUntruncatedMdDtdGridTransformer;
  DemandTransparencyUntruncatedMdDtdGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DemandTransparencyUntruncatedMdDtdGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  DemandTransparencyUntruncatedMdDtdGridTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + this.targetType + '-' + metrics.join('-');
  };
  DemandTransparencyUntruncatedMdDtdGridTransformer.prototype.transform = function (data, metric) {
    if (data.domain.results === undefined) {
      return undefined;
    }
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    metric = metric[0];
    var results = [];
    _.forEach(data.domain.results, function (d) {
      var momentDepartureDate = memoizedMomentOfDate(d.departureDate, momentService.FIELD.DEPARTURE_DATE);
      var r = {
        market: d.origin + '-' + d.destination,
        season: d.season,
        seasonOverride: d.seasonOverride,
        significantPOS: d.significantPOS,
        classGroupName: d.classGroupName,
        departureDate: momentDepartureDate
      };
      var daysToDepartures = d.daysToDepartures;
      var length;
      if (daysToDepartures && daysToDepartures.length) {
        length = daysToDepartures.length;
      }
      for (var i = 0; i < length; i++) {
        var daysToDepartureData = daysToDepartures[i];
        var attrName = 'daysToDeparture' + _.padStart(daysToDepartureData.daysToDeparture, 3, '0');
        r[attrName] = daysToDepartureData.untruncatedResHold[metric];
      }
      results.push(r);
    });
    return results;
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return DemandTransparencyUntruncatedMdDtdGridTransformer;
};
DemandTransparencyUntruncatedMdDtdGridTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = DemandTransparencyUntruncatedMdDtdGridTransformerFactory;